module.exports = __webpack_public_path__ + "static/services-img10-d7707dde3e1b0ac915ab807425c75146.png";